import { useAppDispatch, useAppState } from '@/store';
import { useEffect } from 'react';
import { GetOrdersDTO } from '../dtos';
import { getOrders, ordersSelector } from '../feature';

export const useGetOrders = () => {
  const dispatch = useAppDispatch();

  const data = useAppState(ordersSelector);

  useEffect(() => {
    const dto = new GetOrdersDTO({});
    dispatch(getOrders(dto));
  }, []);

  return data;
};
